import * as actionTypes from './actionTypes';
import axios from '../../services/axios'
import { setMessage } from './message';

export const loadPhonebookData = () => {
    return {
        type: actionTypes.LOAD_PHONEBOOK_DATA
    }
}

export const setPhonebookData = (phonebookData) => {
    return {
        type: actionTypes.SET_PHONEBOOK_DATA,
        phonebookData: phonebookData
    }
}

export const getPhonebookData = (value, currentPage, pageSize) => {
    return (dispatch) => {
        dispatch(loadPhonebookData())
        axios.post(`/api/v1/phone-book`, {
            searchValue: value,
            currentPage: currentPage,
            pageSize: pageSize
        })
            .then(response => {
                dispatch(setPhonebookData(response.data))
            })
            .catch(() => {
                dispatch(setPhonebookData(null))
                dispatch(setMessage({ type: 'warning', text: "Не удалось получить данные." }))
            })
    }
}

